package com.example.mystybag.appCore.model.pages

data class DeleteAccountRequestUIState(
    val enquiryText: String = "",
    val isLoading: Boolean = false,
    val hasPendingRequest: Boolean = false
)
